<template>
  <div class="col-lg-12 col-md-12">
    <div v-if="shopList == null">
      <div class="lds-dual-ring"></div>
    </div>
    <div v-else>
      <div class="row">
        <div class="col">
          <p-button
            round
            outline
            type="info"
            size="sm"
            @click="showAddShopModal()"
            >add store</p-button
          >
        </div>
      </div>
      <div class="row">
        <div class="col">
          <card>
            <el-table :data="shopList" v-if="shopList.length > 0">
              <el-table-column label="Store" width="400">
                <template slot-scope="props">{{ props.row.shop }}</template>
              </el-table-column>

              <el-table-column label="Status">
                <template slot-scope="props">
                  <badge type="success" v-if="props.row.status == 'active'">{{
                    props.row.status
                  }}</badge>
                  <badge type="default" v-if="props.row.status == 'pending'">{{
                    props.row.status
                  }}</badge>
                </template>
              </el-table-column>
              <el-table-column label="Actions">
                <template slot-scope="props">
                  <p-button
                    v-if="props.row.status == 'active'"
                    round
                    outline
                    type="info"
                    size="sm"
                    @click="showArchiveShopModal(props.row._id)"
                    >unlink store</p-button
                  >
                  <p-button
                    v-if="props.row.status == 'pending'"
                    round
                    outline
                    type="info"
                    size="sm"
                    @click="storeRedirect(props.row.shop)"
                    >Install App in Shopify</p-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <div v-else>No Stores</div>
          </card>
        </div>
      </div>
      <modal
        :show.sync="archiveShopAlert"
        :show-close="false"
        :show-header="false"
        type="mini"
      >
        <div style="text-align: center" v-if="selectedShop !== null">
          <h4 style="text-align: center">Remove store?</h4>
          <p style="text-align: center">{{ selectedShop.shop }}</p>
        </div>
        <div style="text-align: center">
          <div style="margin-left: auto; margin-right: auto">
            <p-button
              round
              type="danger"
              text
              @click="archiveShop"
              style="margin: 10px"
              >Yes</p-button
            >
            <p-button
              round
              text
              @click="archiveShopAlert = false"
              style="margin: 10px"
              >Cancel</p-button
            >
          </div>
        </div>
      </modal>

      <modal :show.sync="addShopModal" type="notice">
        <div v-if="addShopAlert == true" class="error-modal">
          {{ addShopAlertMsg }}
        </div>

        <h5 slot="header" class="modal-title">Add Store</h5>
        <fg-input
          label="Shopify Store Url"
          id="shopifyUrl"
          name="shopifyUrl"
          type="text"
          v-model="newShopUrl"
          required
        ></fg-input>

        <div style="text-align: center">
          <div style="margin-left: auto; margin-right: auto">
            <p-button
              round
              type="danger"
              text
              @click="addShop"
              style="margin: 10px"
              >Yes</p-button
            >
            <p-button round text @click="cancelAddShop" style="margin: 10px"
              >Cancel</p-button
            >
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>
<script>
import firebase from "firebase";
import { mapGetters, mapActions } from "vuex";
import {
  Card,
  Checkbox,
  Button,
  Badge,
  Modal,
} from "src/components/UIComponents";

//const client = new Instagram({ username: '', password: '' }, { language: 'es-CL' })

import {
  userLoadApi,
  clientStoreListApi,
  shopifyStoreArchiveApi,
  shopifyStoreCreateApi,
} from "@/config/appSettings";

import axios from "axios";
import store from "@/store/index.js";

export default {
  name: "ShopifyAuth",
  components: {
    Card,
    [Checkbox.name]: Checkbox,
    [Button.name]: Button,
    Badge,
    Modal,
  },
  data() {
    return {
      isConnected: false,
      fbName: "",
      fbEmail: "",
      personalId: "",
      fbPicture: "",
      //FB: undefined,
      isTeam: null,
      isClient: null,
      isInfluencer: null,
      profileDetails: null,
      auth: null,
      relatedProfiles: null,
      noAuthProfiles: [],
      relatedProfileList: null,
      instagramLinked: false,
      loadingOverlay: false,
      loadingOverlayText: null,
      clientId: null,
      shopList: null,
      shopListActive: null,
      shopListPending: null,
      archiveShopAlert: false,
      addShopModal: false,
      addShopAlert: null,
      addShopAlertMsg: null,
      newShopUrl: null,
      selectedShop: null,
    };
  },
  computed: {
    ...mapGetters(["profileStore", "relatedProfileStore"]),
  },
  methods: {
    async storeRedirect(shopUrl) {
      //window.location = `https://${shopUrl}/admin`;
       window.location = `https://apps.shopify.com/helloconvo-influencers`;
    },
    async clientCheck() {},
    async archiveShop() {
      //console.log("UNLINKING:", this.selectedShop.shop);
      let archiveShopResponse = await axios.post(shopifyStoreArchiveApi, {
        shop: this.selectedShop.shop,
        usertoken: this.auth,
      });

      //console.log("ARCHIVE RESPONSE:", archiveShopResponse);
      if (archiveShopResponse.data.success == true) {
        this.loadClientShops();
        ///console.log("DELETE SUCCESS");
        this.selectedShop = null;
        this.archiveShopAlert = false;
        return;
      }
    },
    async showArchiveShopModal(storeId) {
      this.selectedShop = null;
      //console.log("UNLINKING:", storeId);
      let selectShop = this.shopList.filter((x) => {
        return storeId == x._id;
      });
      if (selectShop.length > 0) {
        this.selectedShop = selectShop[0];
        //console.log("SELETED SHOP:", this.selectedShop);
      }
      this.archiveShopAlert = true;
    },
    async cancelAddShop() {
      this.addShopModal = false;
    },
    async addShop() {
      try {
        if (this.newShopUrl == null || typeof this.newShopUrl == "undefined") {
          //console.log("NO SHOP URL");
          return;
        }
        let shopifyUrlClean = this.newShopUrl.replace("https://", "");
        shopifyUrlClean = shopifyUrlClean.replace("http://", "");
        shopifyUrlClean = shopifyUrlClean.replace("/", "");
        //console.log("SHOPIFY URL", shopifyUrlClean);
        /*let shopifyUrlCheckResponse = await axios.get(
          `https://${shopifyUrlClean}`
        );

        if (shopifyUrlCheckResponse.status !== "200") {
          console.log("URL CHECK FAILED");
          return;
        }*/

        let addShopResponse = await axios.post(shopifyStoreCreateApi, {
          shop: shopifyUrlClean,
          usertoken: this.auth,
          client: this.clientId,
        });

        //console.log("ADD SHOP RESPONSE:", addShopResponse)

        if (addShopResponse.data.success == true) {
          await this.loadClientShops();

          this.newShopUrl = null;
          this.addShopModal = false;
          return;
        }
        if (addShopResponse.data.success == false) {
          if (addShopResponse.data.error == "shop exists") {
            this.addShopAlert = true;
            this.addShopAlertMsg =
              "Shop Exists. Please delete app from your Shopify store before adding URL to this dashboard.";
          }
        }
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },
    async showAddShopModal() {
      this.newShopUrl = null;
      this.addShopModal = true;
    },
    async loadClientShops() {
      try {
        let clientShopListUrl = `${clientStoreListApi}/?usertoken=${this.auth}&client=${this.clientId}`;

        let clientShopListResponse = await axios.get(clientShopListUrl);

        if (clientShopListResponse.data.success == true) {
          //console.log(" RESULT: ", clientShopListResponse.data.result);
          this.shopList = clientShopListResponse.data.result;
          return;
        }
        this.shopList = [];
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },
    async loadPageData() {
      await this.loadClientShops();
    },
  },
  mounted() {
    this.loadingOverlay = true;
    this.loadingOverlayText = "Loading...";
    this.auth = firebase.auth().currentUser.uid;
    if (typeof this.$route.params.clientId !== "undefined") {
      this.clientId = this.$route.params.clientId;
      this.loadPageData();
    }
  },
};
</script>
<style scoped>
</style>